// Caps how many integrations can be selected for export in the UI, so users
// get feedback before submitting instead of only on a 422 from the API's own
// batch-size limit. REACT_APP_MAX_INTEGRATIONS_EXPORT_SIZE lets each
// environment override this independently of the API's own limit.
const MAX_EXPORT_SIZE =
  Number(process.env.REACT_APP_MAX_INTEGRATIONS_EXPORT_SIZE) || 15;

export default MAX_EXPORT_SIZE;
